import React from 'react'
import injectSheet from 'react-jss'
import styles from './assessment-skeleton.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import Bone from 'pobble-components/dist/bone'
import EntrySkeleton from './entry-skeleton/entry-skeleton'

const AssessmentSkeleton = ({ classes }) => (
  <Table>
    <thead>
      <tr>
        <HeadCell className={classes.allCell}>
          <Bone className={classes.all} />
        </HeadCell>
        <HeadCell className={classes.dateCell}>
          <Bone className={classes.date} />
        </HeadCell>
        <HeadCell className={classes.titleCell}>
          <Bone className={classes.title} />
        </HeadCell>
        <HeadCell className={classes.contributorsCell}>
          <Bone className={classes.contributors} />
        </HeadCell>
        <HeadCell className={classes.conclusionCell}>
          <Bone className={classes.conclusion} />
        </HeadCell>
        <HeadCell className={classes.contextMenuCell}>
          <Bone className={classes.bulkAction} />
        </HeadCell>
      </tr>
    </thead>
    <tbody>
      <EntrySkeleton titleWidth={30} />
      <EntrySkeleton titleWidth={50} />
      <EntrySkeleton titleWidth={20} />
      <EntrySkeleton titleWidth={60} />
      <EntrySkeleton titleWidth={25} />
    </tbody>
  </Table>
)

export default injectSheet(styles)(AssessmentSkeleton)
